import { createContext } from "react";
export const ActiveEditorContext = createContext({
  activeEditor: null,
  setActiveEditor: () => {},
}); 